import React from "react";
import StatusBadge, {
  StatusBadgeColorVariant,
} from "@/shared/components/StatusBadge";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { SettlementStatus } from "@/features/my-order/features/settlement-management/types";

interface Props {
  status?: SettlementStatus;
}

function SettlementRemittanceStatusBadge({ status }: Props) {
  const { tTitle } = useI18nHelper();
  const statusMap: Record<SettlementStatus, StatusBadgeColorVariant> = {
    PENDING: "white",
    REMITTED: "green",
    UNREMITTED: "red",
  };

  if (!status) return null;

  return (
    <StatusBadge
      status={tTitle(`settlement:remittance_status.${status.toLowerCase()}`)}
      colorVariant={statusMap[status]}
      size={"medium"}
    />
  );
}

export default SettlementRemittanceStatusBadge;
